import React from 'react';
import { compose, withHandlers, setDisplayName } from 'recompose';
import styled from '@emotion/styled';
import { themeGet } from 'styled-system';
import * as R from 'ramda';
import Flex from '@influitive/secret-garden/lib/flex';

const Image = styled.img`
  height: ${themeGet('spacing.7')}px;
  width: ${themeGet('spacing.7')}px;
  margin: 0 ${themeGet('spacing.3')}px ${themeGet('spacing.3')}px 0;
  border-radius: ${themeGet('container.radius.2')}px;
  box-sizing: border-box;
  cursor: pointer;

  ${props => props.isSelected && `
    border: 1px dashed ${props.theme.colors.neutral[2]};
  `}
`;

export default compose(
  withHandlers({
    toggleBadge: ({ selectedBadges, setSelectedBadges }) => event => {
      const currentValue = selectedBadges[event.target.id];

      setSelectedBadges(
        R.pipe(
          R.assoc(event.target.id, !currentValue),
          R.pickBy(R.equals(true))
        )(selectedBadges)
      );
    }
  }),
  setDisplayName('BadgeIcon')
)(({ badges, toggleBadge, selectedBadges }) =>
  <Flex flexWrap='wrap'>
    {badges.map(badge =>
      <Image
        src={badge['icon-url']}
        title={badge.name}
        id={badge.id}
        key={badge.id}
        isSelected={selectedBadges[badge.id]}
        onClick={toggleBadge} />
    )}
  </Flex>
);
